// ----------------------
// UTILS
// ----------------------

//-- JQUERY VALIDATE
$('.js-form-validate').validate({
	errorPlacement: function(error, element) {
	    error.insertBefore(element);
	}
});

$('.js-form-newsletter').validate();

//-- ANCHOR ANIMATION
$('a[href^="#"]').click(function(){
	var href = $(this).attr('href');

	$('html, body').animate({
		scrollTop: $(href).offset().top
	}, 'slow');

	return false;
});

function matchCustom(params, data) {
    // If there are no search terms, return all of the data
    if ($.trim(params.term) === '') {
      return data;
    }

    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined') {
      return null;
    }

    // `params.term` should be the term that is used for searching
    // `data.text` is the text that is displayed for the data object
    if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
      var modifiedData = $.extend({}, data, true);

      // You can return modified objects from here
      // This includes matching the `children` how you want in nested data sets
      return modifiedData;
    }

    // Return `null` if the term should not be displayed
    return null;
}

//-- CUSTOM SELECT
$('.js-select').each(function(){
  var placeholder = $(this).attr('placeholder');

  $(this).select2({
    "placeholder": placeholder,
    "language": {
			"noResults": function(){
				return "Aucun résultat";
			}
 		},
 		matcher: matchCustom
  });
});